import { render, staticRenderFns } from "./TextareaAutoshrinkFont.vue?vue&type=template&id=95d23dd8&"
import script from "./TextareaAutoshrinkFont.vue?vue&type=script&lang=js&"
export * from "./TextareaAutoshrinkFont.vue?vue&type=script&lang=js&"
import style0 from "./TextareaAutoshrinkFont.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('95d23dd8', component.options)
    } else {
      api.reload('95d23dd8', component.options)
    }
    module.hot.accept("./TextareaAutoshrinkFont.vue?vue&type=template&id=95d23dd8&", function () {
      api.rerender('95d23dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/TextareaAutoshrinkFont.vue"
export default component.exports